export const translateMixin = {
    methods: {
        t(key) {
            // @ts-ignore
            return window.TarkPay.translate(key);
        },
    }
}